import React from "react";

/**
 * Brand logo + name. Use `variant="compact"` for header bars (small logo + title)
 * and `variant="hero"` for centered title pages (login/register).
 */
export default function Brand({ variant = "compact", title, subtitle, className = "" }) {
  const sizes = {
    hero: "h-16 sm:h-24",
    large: "h-16",
    compact: "h-9 sm:h-10",
    sm: "h-7",
  };
  const sizeCls = sizes[variant] || sizes.compact;
  const Logo = (
    <img
      src={`${process.env.PUBLIC_URL || ""}/logo.png`}
      alt="Barn's"
      className={`${sizeCls} w-auto object-contain select-none`}
      draggable={false}
      data-testid="brand-logo"
    />
  );

  if (variant === "hero") {
    return (
      <div className={`flex flex-col items-center gap-3 ${className}`}>
        <div className="bg-white rounded-2xl shadow-lg p-3 ring-1 ring-emerald-100">
          {Logo}
        </div>
        {title && <h1 className="text-2xl sm:text-3xl font-bold text-emerald-800 tracking-tight text-center">{title}</h1>}
        {subtitle && <p className="text-sm text-gray-500 text-center">{subtitle}</p>}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-compact">
      <div className="bg-white rounded-lg p-1 shadow-sm">{Logo}</div>
      {title && (
        <div className="leading-tight">
          <div className="text-white font-bold text-sm sm:text-base">{title}</div>
          {subtitle && <div className="text-[10px] text-white/70">{subtitle}</div>}
        </div>
      )}
    </div>
  );
}
